import DealSelect from './DealSelect'

export * from './DealSelect'

export default DealSelect
